import 'core-js/stable'
import Vue from 'vue'
//import CoreuiVuePro from '@coreui/vue-pro'
import CoreuiVuePro from '../node_modules/@coreui/vue-pro/src/index.js'
import App from './App'
import router from './router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import i18n from './i18n.js'
import filters from './filters';
import moment from 'moment'

import './bootstrap';
require('@/bootstrap');

import ws from './services/login';
import emergencyService from './services/emergency';

Vue.use(CoreuiVuePro)
Vue.prototype.$log = console.log.bind(console)

Vue.use(filters);
Vue.use(moment);

router.beforeEach(async (to, from, next) => {
  const isEmergencyResumeRoute = to.name === 'emergency-resume'
  const isMaintenanceRoute = to.name === 'maintenance'

  if (isEmergencyResumeRoute) {
    next();
    return;
  }

  let sitePaused = false

  try {
    const emergency = await emergencyService.status()
    sitePaused = !!(emergency && emergency.data && emergency.data.site_paused)
  } catch (error) {
    sitePaused = false
  }

  if (sitePaused && !isEmergencyResumeRoute && !isMaintenanceRoute) {
    next({ name: 'maintenance' })
    return
  }

  if (!sitePaused && isMaintenanceRoute) {
    next({ path: '/login' })
    return
  }

  if(to.meta.is_public){
    next(); return;
  }
  else{
    if (localStorage.getItem("token") == null) {     
      next({
        path: "/login",
        params: { nextUrl: to.fullPath },
      });
    }
    else{
      try {
        let response;
        if(to.meta.is_admin){
          response = await ws.validateAdmin({token: localStorage.getItem("token")});
        }else{
          response = await ws.validate({token: localStorage.getItem("token")});
        }

        if(response.type == "success"){
          next();
        }
        else{
          next({
            path: "/login",
            params: { nextUrl: to.fullPath },
          });
        }
      } catch (error) {
        const status = error && error.response && error.response.status;

        if (status === 503) {
          next({ name: '404' });
          return;
        }

        next({
          path: "/login",
          params: { nextUrl: to.fullPath },
        });
      }
    }
  }
});

new Vue({
  el: '#app',
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  i18n,
  template: '<App/>',
  components: { 
    App
  }
})
